



















import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import moment from 'moment';


export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toSumupUnitCurriculumEdit = () => {
      context.root.$router.push(`/teacher_site/practice_sumup_unit_curriculum_edit/${context.root.$route.params.sumup_group_id}`);
    };
    
    const toSumupUnitMultiEdit = () => {
      context.root.$router.push(`/teacher_site/practice_sumup_unit_multi_edit/${context.root.$route.params.sumup_group_id}`);
    };

    const toSumupUnitCourseEdit = () => {
      context.root.$router.push(`/teacher_site/practice_sumup_unit_course_edit/${context.root.$route.params.sumup_group_id}`);
    };

    const toAssessmentEdit = () => {
      context.root.$router.push(`/teacher_site/practice_sumup_assessment_edit/${context.root.$route.params.sumup_group_id}`);
    };


    return {
      toSumupUnitCurriculumEdit,
      toSumupUnitMultiEdit,
      toSumupUnitCourseEdit,
      toAssessmentEdit,
    };
  }
})
